import React, { useState } from "react";

const RelSVB = () => {
  return (
    <>
      <div className="row pb-3">
        <div className="col-md-12">
          <div className="card px-3 py-2">
            <div className="row">
              <div className="col-md-12 ">
                <div className="d-fle">
                  <input type="checkbox" />
                  <label className="form-label ms-2">
                    Are Buyer & Seller Related?
                  </label>
                </div>
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Relation</label>
                <input type="text" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Base</label>
                <input type="text" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Condition</label>
                <input type="text" className="form-control form-control-sm" />
              </div>
              <hr className="mt-2" />
              <div className="col-md-12 ">
                <div className="d-fle">
                  <input type="checkbox" />
                  <label className="form-label ms-2">
                  SVB Loading
                  </label>
                </div>
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">SVB Ref No.</label>
                <input type="text" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">SVB Ref Date</label>
                <input type="date" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Custom House</label>
                <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Loading On</label>
                <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Rate(Assbl.)</label>
                <div className="d-flex">
                      <input type="text" className="form-control form-control-sm" />
                      <label>%</label>
                      </div>
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Status</label>
                <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Rate(Duty)</label>
                <div className="d-flex">
                      <input type="text" className="form-control form-control-sm" />
                      <label>%</label>
                      </div>
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Status</label>
                <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RelSVB;
